import { render, staticRenderFns } from "./UnlinkDiscountDialog.vue?vue&type=template&id=5816d5c0&scoped=true&"
import script from "./UnlinkDiscountDialog.vue?vue&type=script&lang=js&"
export * from "./UnlinkDiscountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5816d5c0",
  null
  
)

export default component.exports